import React, { useEffect, useState } from "react"
import { History } from "history"
import LRHLogo from "./logos/lrh-logo.svg"
import { getDynamicTitleWithRoute } from "../../utils/utils"

interface DynamicTitleProps {
  history: History
}

const DynamicTitle = ({ history }: DynamicTitleProps) => {
  const dynamicTitle = getDynamicTitleWithRoute(history.location.pathname)
  const isLRH = history.location.pathname.includes("/lrh")
  const [doesSecondaryLogoExist, setDoesSecondaryLogoExist] = useState(false)

  useEffect(() => {
    const checkSecondaryLogo = async () => {
      try {
        const result = await fetch("/public/images/secondary-logo.svg", {
          method: "GET",
        })
        const contentType = result.headers.get("Content-Type")
        setDoesSecondaryLogoExist(contentType.includes("image/svg+xml"))
      } catch (e) {
        console.error(e)
        setDoesSecondaryLogoExist(false)
      }
    }

    checkSecondaryLogo()
  }, [])

  return (
    <>
      {doesSecondaryLogoExist && (
        <img
          id="secondary-logo"
          src="/public/images/secondary-logo.svg"
          alt="Secondary logo"
          style={{ maxWidth: "128px" }}
        />
      )}
      {!doesSecondaryLogoExist && isLRH && (
        <img
          id="secondary-logo"
          src={LRHLogo}
          alt="Secondary logo"
          style={{ maxWidth: "278px" }}
        />
      )}

      {!doesSecondaryLogoExist && dynamicTitle && !isLRH && (
        <h2 className="text-xl font-medium whitespace-nowrap">
          {dynamicTitle}
        </h2>
      )}
    </>
  )
}

export default DynamicTitle
